import { faAmazon, faDiscord, faFacebook, faInstagram, faLinkedin, faTiktok, faXTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withTranslation } from 'react-i18next';

import {
  BUILD,
  DEVICE,
  SOCIAL_AMAZON,
  SOCIAL_DISCORD,
  SOCIAL_FACEBOOK,
  SOCIAL_INSTAGRAM,
  SOCIAL_LINKEDIN,
  SOCIAL_TIKTOK,
  SOCIAL_TWITTER_EN,
  SOCIAL_TWITTER_FR,
  SOCIAL_YOUTUBE,
} from '../../../config';
import { useLanguage } from '../../../contexts/LanguageContext';
import { isPWAInstallAvailable, triggerPWAInstall } from '../../../pwa';
import Action from '../../Action';
import Logo from '../../Atoms/Logo';

import * as style from './style.module.css';

const Footer = ({ t, user, onObtainBadge }) => {
  const { currentInterfaceLanguage } = useLanguage();

  const handleDiscord = async () => {
    onObtainBadge('b823f252-ec0f-414c-ab9e-47a9491af2d8');
  };

  return (
    <footer className={style.footer}>
      <div className={style.content}>
        <Action action="/" className={style.logo}>
          <Logo language={currentInterfaceLanguage} />
        </Action>
        <span className={style.text}>
          <Action className={style.team} action="/team/">
            {t('Brickfilms.com © 2000 - {{year}}. All works copyright of their respective creators.', { year: new Date().getFullYear() })}
          </Action>
          <p>{t('Brickfilms™ is the registered trademark of Brick à Brack. All rights reserved.')}</p>
          <p>{t('LEGO® is a trademark of the LEGO Group which does not sponsor, authorize or endorse this site.')}</p>
          <p className={style.linkContainer}>
            <Action className={style.link} action="/about-us/">
              {t('About us')}
            </Action>
            <Action className={style.link} action="/events/">
              {t('Exhibitions')}
            </Action>
            {!user?.isPremium && <Action className={style.link} action="/offers/">
              {t('Become premium')}
            </Action>}
            {user?.isPremium && <Action className={style.link} action="/offers/">
              {t('Our offers')}
            </Action>}
            <Action className={style.link} action="/stats/">
              {t('Stats')}
            </Action>
            <Action className={style.link} action="/rules/">
              {t('Rules')}
            </Action>
            <Action className={style.link} action="/community/VGhyZWFkOjM3NjQ3/brickfilmscom-release-notes">
              {t('Release notes')}
            </Action>
            <Action className={style.link} action="/legal-notices/">
              {t('Legal notices')}
            </Action>
            {DEVICE === 'WEB' && isPWAInstallAvailable() && (
              <Action className={style.link} action={triggerPWAInstall}>
                {t('Install as app')}
              </Action>
            )}
          </p>
        </span>
        <span className={style.externalIcons}>
          <Action action={SOCIAL_INSTAGRAM}>
            <FontAwesomeIcon icon={faInstagram} title={t('Instagram')} />
          </Action>
          <Action action={SOCIAL_TIKTOK}>
            <FontAwesomeIcon icon={faTiktok} title={t('Tiktok')} />
          </Action>
          <Action action={[
            ...(user ? [handleDiscord] : []),
            SOCIAL_DISCORD
          ]}>
            <FontAwesomeIcon icon={faDiscord} title={t('Discord')} />
          </Action>
          <Action action={SOCIAL_YOUTUBE}>
            <FontAwesomeIcon icon={faYoutube} title={t('Youtube')} />
          </Action>
          <div className={style.brk} />
          <Action action={SOCIAL_FACEBOOK}>
            <FontAwesomeIcon icon={faFacebook} title={t('Facebook')} />
          </Action>
          <Action action={currentInterfaceLanguage === 'fr' ? SOCIAL_TWITTER_FR : SOCIAL_TWITTER_EN}>
            <FontAwesomeIcon icon={faXTwitter} title={t('X')} />
          </Action>
          <Action action={SOCIAL_LINKEDIN}>
            <FontAwesomeIcon icon={faLinkedin} title={t('LinkedIn')} />
          </Action>
          <Action action={SOCIAL_AMAZON}>
            <FontAwesomeIcon icon={faAmazon} title={t('Amazon')} />
          </Action>
        </span>
      </div>
      <span className={style.build}>{BUILD}</span>
    </footer>
  );
};

export default withTranslation()(Footer);
